<template>
<div class="chapter">
<div class="inner_page">
<p class="center">This book honors my wonderful wife Melisa.</p>
<p class="center">We met through running. We have run many miles together in some extraordinary places in the world. Her tireless and unselfish support of my coaching over almost thirty years is a constant source of inspiration to me. Being “Mrs. Coach” is not easy. The endless hours I spent buried in spreadsheets, and the time I spent on Saturdays at invitationals was time not spent with her. The amount of grace required for planning personal vacations and trips around my coaching schedule is a testament to how special a woman she is—a special wife. <em class="italic">Special</em>!</p>
<p class="center">Thanks for always believing in me and supporting me.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?b2ffa9b6